import { Component, Input, OnInit } from '@angular/core';
import { ModalBase, template } from 'curvy';
import { Task } from '@task-utils/types';
import { TaskRoutes } from '@task-utils/routes';
import { User } from '@task-modules/users';

interface ShortLocation {
	location_id: number;
	cin: string;
	name: string;
	address: string;
};

@Component({
    selector: 'task-qrcode-dialog',
    template: `
        @if (is_admin) {
           <knw-auto-search
                #locpicker
                [required]="true"
                [function]="search_locations"
                [to-label]="format_location_name"
                label="{{ 'LOCATION' | trans }}"
                [(ngModel)]="picked_location"
                (ngModelChange)="get_qr(type, $event.location_id)"
                [popover-width]="'auto'"
            >
            </knw-auto-search>
        }
        
        @if (img) {
            @for (image of [img]; track image.HTMLString) {
                <div [table-display]="img"></div>
            }
        }

        <button (click)="submit(null)">{{ "CLOSE" | trans }}</button>
    `
})
export class QrCodeDialog extends ModalBase<'start' | 'end', any> implements OnInit {
    preventSoftClose = true;

    get type() {
        return this.injectedData;
    }


    user: User.Current;
    location_id: number;
	picked_location:ShortLocation;


    img: template.EscapedHTML = null;

    is_admin = false;
    
    async get_qr(type: 'start' | 'end', location_id: number) {
        let res: Blob | null = null;
        if (type === 'start') {
            res = await TaskRoutes.temp_staff_requests.api_temp_staff_qr_code_start(location_id);
        } else {
            res = await TaskRoutes.temp_staff_requests.api_temp_staff_qr_code_end(location_id);
        }

        if (res && res.type.startsWith("image/")) {
            this.img = template.transform("<img src='{{src}}'/>", { src: URL.createObjectURL(res) });
        }
    }

    async get_user() {
        this.user = await User.currentUserPromise;
        this.is_admin = this.user.user_type_id == Task.USER_TYPE.ADMIN || 
            this.user.user_type_id == Task.USER_TYPE.SYSTEM_ADMIN;
        this.location_id = this.user.locations[0]?.location_id;
    }

    async search_locations(search: string) {
        let res = await TaskRoutes.locations.api_location_search_visible(
            { search: [search], attributes: ["cin+ +name"] },
            { page_no: 1, page_size: 50 }
        );
        return res.data;
    }

    format_location_name(loc: Task.Location) {
        if (!loc) { return ""; }
		return `${loc.cin ?? ''} ${loc.name}`;
    }

    interval = null;

    ngOnInit(): void {
        this.get_user().then(() => {
            if (this.location_id) {
                this.get_qr(this.type, this.location_id);
            }
        });

        this.interval = setInterval(() => {
            this.get_qr(this.type, this.location_id);
        }, 1000*60*2.5);
    }

    ngOnDestroy() {
        clearInterval(this.interval);
    }
}
